import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PendingGuard {

  constructor(private route: Router, private authService: AuthService) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let role = this.authService.getRole();

    if (!role || role == 'Pending') {
      return true;
    }
    this.route.navigateByUrl('/')
    return false
  }
}
